import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const modify_user = (
  id,
  username,
  password,
  nickname,
  telegramId,
  qunid,
  roleType,
  money,
  image
) => {
  return api.post(`${ApiEndpointConstants.ADDUSER}`, {
    id,
    username,
    password,
    nickname,
    telegramId,
    qunid,
    roleType,
    money,
    image,
  });
};
